// extracted by mini-css-extract-plugin
export var button = "index-module--button--75a00";
export var checked = "index-module--checked--9fdeb";
export var copied = "index-module--copied--3e7ac";
export var copiedText = "index-module--copiedText--034ae";
export var copyIcon = "index-module--copyIcon--77338";
export var icon = "index-module--icon--588f7";
export var success = "index-module--success--c9356";